import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (
    _event: React.MouseEvent<HTMLElement>,
    newLanguage: string | null
  ) => {
    if (newLanguage !== null) {
      i18n.changeLanguage(newLanguage);
      // Save language preference to localStorage
      localStorage.setItem('userLanguage', newLanguage);
    }
  };

  return (
    <Box sx={{ mx: 1 }}>
      <Tooltip title={t('switchLanguage')}>
        <ToggleButtonGroup
          value={i18n.language}
          exclusive
          onChange={handleLanguageChange}
          aria-label={t('switchLanguage')}
          size="small"
        >
          <ToggleButton value="en" aria-label="English">
            EN
          </ToggleButton>
          <ToggleButton value="sr" aria-label="Serbian">
            SR
          </ToggleButton>
        </ToggleButtonGroup>
      </Tooltip>
    </Box>
  );
};

export default LanguageSwitcher;